import { WorkPeriodEvent } from '../api/work-period-events'
import locales from '../../../locales/work-period-events'

export const buildWorkPeriodEventLabel = (
  event: WorkPeriodEvent,
  hideType: boolean = false,
): string => `${event.code} - ${event.title} ${hideType ? '' : `- (${locales.types[event.type]})`}`
